import { observable } from "@legendapp/state";
import { persistObservable } from "@legendapp/state/persist";
import { ObservablePersistLocalStorage } from "@legendapp/state/persist-plugins/local-storage";

export enum LoginStatus {
  Pending = "pending",
  Success = "success",
  LoggedOut = "logged_out"
}

export const authStore = observable({
  accessToken: "",
  refreshToken: "",
  loginStatus: LoginStatus.Pending as LoginStatus,
  tokenVersion: 0
});

persistObservable(authStore, {
  local: "auth_store",
  pluginLocal: ObservablePersistLocalStorage
});
